<template>
	<div class="flex flex-col md:grid grid-cols-3 gap-8">
		<div class="col-span-2 flex flex-col gap-8">
			<slot />
		</div>
		<div>
			<div class="sticky top-56 lg:top-36 flex flex-col gap-12">
				<slot name="sidebar" />
			</div>
		</div>
	</div>
</template>
